import React, { useState } from "react";
import { Card, Avatar, Button, Dropdown, Menu, Typography, message,Tooltip } from "antd";
import { SmileOutlined, CommentOutlined, MoreOutlined, DownloadOutlined, FileOutlined, FilePdfOutlined } from "@ant-design/icons";
import ChatEditor from "./ChatEditor";
import { convertDateToUserTimezone } from "../Components/Utility";
import { DateTimeFormat } from "../Components/Constant";
import ReactDOM from "react-dom";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";


const { Text } = Typography;

export default function CommentCard({
    comment,
    users,
    onReact,
    handleSend,
    onCancel,
    handleEditReply,
    isReplyEditing = false,
    isReply = false,
    setReplyingTo,
    isRichTextField=false,

}) {
    const userId = Cookies.get("userId");
    const navigate = useNavigate();
    const [isEditing, setIsEditing] = useState(false);
    const [isReplying, setIsReplying] = useState(false);
    const [editingIdx, setEditingIdx] = useState(null);
    const [editInitial, setEditInitial] = useState(null);
    const [preview, setPreview] = useState({ visible: false, type: null, src: null, filename: null });
    const [editingReply, setEditingReply] = useState(null);
    const [editingReplyInitial, setEditingReplyInitial] = useState(null);
    const user = comment.user || comment.sender || comment.author || {};

    const emojiMenu = (id) => ({
        items: [
            { key: "1", label: <span onClick={() => onReact(id, "👍")}>👍</span> },
            { key: "2", label: <span onClick={() => onReact(id, "❤️")}>❤️</span> },
            { key: "3", label: <span onClick={() => onReact(id, "😂")}>😂</span> },
            { key: "4", label: <span onClick={() => onReact(id, "🎉")}>🎉</span> },
        ],
    });

    const handleEditStart = () => {
        setEditInitial({ html: comment.content, files: comment.attachments });
        setIsEditing(true);
    };

    const handleEditCancel = () => {
        setIsEditing(false);
        setEditInitial(null);
        if (onCancel) onCancel();
    };

    const handleReplyCancel = () => {
        setIsReplying(false);
        if (onCancel) onCancel();
    };

    const handleAttachmentPreview = (a) => {
        const base64 =
            a?.base64code ||
            a?.base_64_data ||
            (a?.content && (a.content.$binary && a.content.$binary.base64)) ||
            a?.content ||
            a?.base64 ||
            "";
        const ext = (a.filename || "").split(".").pop().toLowerCase();
        const isImage = ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(ext);
        const isPdf = ext === "pdf";

        if (!base64) return message.error("No file data available for preview");

        if (isImage) setPreview({ visible: true, type: "image", src: `data:image/${ext};base64,${base64}`, filename: a.filename });
        else if (isPdf) setPreview({ visible: true, type: "pdf", src: `data:application/pdf;base64,${base64}`, filename: a.filename });
        else message.info("Preview not available for this file type. Please download.");
    };

    const handleDownload = (a) => {
        const base64 =
            a?.base64code ||
            a?.base_64_data ||
            (a?.content && (a.content.$binary && a.content.$binary.base64)) ||
            a?.content ||
            a?.base64 ||
            "";
        if (!base64) return message.error("No file data available to download");
        const link = document.createElement("a");
        link.href = `data:application/octet-stream;base64,${base64}`;
        link.download = a.filename || "download";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Card
            className="message-wrapper"
            style={{
                marginBottom: 5,
                marginLeft: isReply ? 50 : 0,
                borderLeft: isReply ? "2px solid #eee" : "none",
                paddingLeft: isReply ? 10 : 0,
            }}
        >
          
            {!isRichTextField && (
          <>
            {/* --- Header (User + Date) --- */}
            <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
                {user?.image ? (
                    <img
                        src={`data:image/jpeg;base64,${user.image}`}
                        alt={user.name || "User"}
                        style={{ width: 24, height: 24, borderRadius: 13, marginRight: 8, objectFit: "cover" }}
                    />
                ) : (
                    <Avatar size="small" style={{ backgroundColor: "#87d068", marginRight: 8 }}>
                        {user?.name?.charAt(0).toUpperCase()}
                    </Avatar>
                )}
                <div style={{ flex: 1 }}>
                    <b>{user.name || user.displayName || "Unknown"}</b>
                    <Text type="secondary" style={{ fontSize: 12, marginLeft: 6 }}>
                        {convertDateToUserTimezone(comment.created_at, DateTimeFormat)}
                    </Text>
                </div>
            </div>

            <div className="message-actions">
                        <Dropdown
                            menu={emojiMenu(comment.id)}
                            trigger={["click"]}
                            placement="topRight"
                        >
                            <Button
                                type="text"
                                icon={<SmileOutlined />}
                                title="React"
                            />
                        </Dropdown>
                {!isReply && (
                    <>
                        <Button
                            type="text"
                            icon={<CommentOutlined />}
                            title="Reply"
                            onClick={() =>
                                console.log('Reply clicked for comment id:', comment.id) ||
                                setReplyingTo((prev) => (prev === comment.id ? null : comment.id))
                            }
                        />
                    </>
                )}

                <Dropdown
                    overlay={
                        <Menu>
                            <Menu.Item
                                key="edit"
                                onClick={() => {
                                    setEditingIdx(comment.id);
                                    setEditInitial({ html: comment.content, files: comment.attachments, id: comment.id });
                                    setIsEditing(true);
                                }}
                            >
                                Edit
                            </Menu.Item>
                        </Menu>
                    }
                    trigger={["click"]}
                    placement="topRight"
                >
                    <Button type="text" icon={<MoreOutlined />} title="More" />
                </Dropdown>
            </div>
            </>
            )}

            {/* --- Edit Mode --- */}
            {isEditing ? (
                <ChatEditor
                    onSend={isReplyEditing ? handleEditReply : handleSend}
                    showTools={true}
                    prefill={editInitial?.html}
                    editAttachments={editInitial?.files}
                    editMode={true}
                    users={users}
                    onCancel={handleEditCancel}

                />
            ) : (
                <>
                    {/* --- Message Body --- */}
                <div
                  className="rendered-message"
                  onClick={(e) => {
                    // if a mention element in the rendered message is clicked, navigate to /<id>
                    const el = e.target.closest && e.target.closest("[data-mention-id]");
                    if (el) {
                      const id = el.getAttribute("data-mention-id");
                        if (id) navigate(`/record/User/${id}`); 
                    }
                  }}
                >
                  <div dangerouslySetInnerHTML={{ __html:  comment.content }} />
                </div>


                  {!isRichTextField && (
                    <>
                    {/* --- Attachments --- */}
                    {Array.isArray(comment.attachments) && comment.attachments.length > 0 && (
                        <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 2 }}>
                            {comment.attachments.map((a, i) => {
                                const ext = (a.filename || "").split(".").pop().toLowerCase();
                                const isImage = ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(ext);
                                const isPdf = ext === "pdf";
                                return (
                                    <div
                                        key={i}
                                        style={{
                                            width: 80,
                                            height: 80,
                                            border: "1px solid #e0e0e0",
                                            borderRadius: 8,
                                            background: "#fafbfc",
                                            position: "relative",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => handleAttachmentPreview(a)}
                                    >
                                        <DownloadOutlined
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDownload(a);
                                            }}
                                            style={{
                                                position: "absolute",
                                                top: 8,
                                                right: 8,
                                                fontSize: 16,
                                                color: "#1677ff",
                                                background: "#fff",
                                                borderRadius: "50%",
                                                padding: 2,
                                            }}
                                        />
                                        {isImage ? (
                                            <img
                                                src={`data:image/${ext};base64,${a.base_64_data}`}
                                                alt={a.filename}
                                                style={{ maxWidth: 60, maxHeight: 60 }}
                                            />
                                        ) : isPdf ? (
                                            <FilePdfOutlined style={{ fontSize: 40, color: "#d32f2f" }} />
                                        ) : (
                                            <FileOutlined style={{ fontSize: 40, color: "#888" }} />
                                        )}

                                        <Tooltip title={a.filename} placement="bottom">

                                        <div
                                            style={{
                                                fontSize: 11,
                                                textAlign: "center",
                                                wordBreak: "break-word",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                width: "90%", // keep a bit of margin
                                            }}
                                           >
                                            {a.filename}
                                        </div>
                                        </Tooltip>
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {/* --- Reactions --- */}
                    {Array.isArray(comment.reactions) && comment.reactions.length > 0 && (
                        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 0 }}>
                            {comment.reactions.map((r, i) => {
                                const hasReacted = r.users?.includes(userId);
                                return (
                                    <div
                                        key={i}
                                        onClick={() => hasReacted && onReact(comment.id, r.emoji)}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 3,
                                            padding: "2px 6px",
                                            borderRadius: 16,
                                            background: hasReacted ? "#e6f4ff" : "#f5f5f5",
                                            border: hasReacted ? "1px solid #91caff" : "1px solid transparent",
                                            cursor: hasReacted ? "pointer" : "not-allowed",
                                        }}
                                    >
                                        <span>{r.emoji}</span>
                                        <span style={{ fontSize: 12 }}>{r.count}</span>
                                    </div>
                                );
                            })}

                            <Dropdown menu={emojiMenu(comment.id)} trigger={["click"]} placement="topRight">
                                <div
                                    style={{
                                        position: "relative",
                                        width: 28,
                                        height: 28,
                                        borderRadius: "50%",
                                        background: "#f5f5f5",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        border: "1px solid #ddd",
                                        transition: "background 0.2s",
                                    }}
                                    title="Add Reaction"
                                >
                                    <SmileOutlined style={{ fontSize: 12, color: "black" }} />
                                    <span
                                        style={{
                                            position: "absolute",
                                            top: "-1px",
                                            right: "-2px",
                                            fontSize: 12,
                                            color: "black",
                                            fontWeight: "bold",
                                            background: "white",
                                            borderRadius: "50%",
                                            lineHeight: 1,
                                        }}
                                    >
                                        +
                                    </span>
                                </div>
                            </Dropdown>
                        </div>
                    )}
                    </>

                    )}


                </>
            )}


            {/* --- Preview Modal --- */}
            {preview.visible &&
                ReactDOM.createPortal(
                    <div
                        style={{
                            position: "fixed",
                            inset: 0,
                            background: "rgba(0,0,0,0.5)",
                            zIndex: 9999,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        onClick={() => setPreview({ visible: false, type: null, src: null, filename: null })}
                    >
                        <div
                            style={{
                                background: "#fff",
                                padding: 20,
                                borderRadius: 8,
                                position: "relative",
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div
                                style={{ position: "absolute", right: 10, top: 5, cursor: "pointer" }}
                                onClick={() => setPreview({ visible: false, type: null, src: null, filename: null })}
                            >
                                ✕
                            </div>
                            {preview.type === "image" && (
                                <img
                                    src={preview.src}
                                    alt={preview.filename}
                                    style={{ maxWidth: "80vw", maxHeight: "80vh" }}
                                />
                            )}
                            {preview.type === "pdf" && (
                                <iframe
                                    src={preview.src}
                                    title={preview.filename}
                                    style={{ width: "70vw", height: "70vh", border: "none" }}
                                />
                            )}
                        </div>
                    </div>,
                    document.body
                )}
        </Card>
    );
}
